import {
  LOADER
} from '../../reduxs'

export const displayLoader = (status) => {
  return {
    type: LOADER.actionType.DISPLAY_LOADER,
    status
  }
}
